import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { SchoolUser } from 'Src/models/schoolUser';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Users.css';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  user: SchoolUser;
}

// report 023
export function UserActivityDetailsReportForm(props: Props) {
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    <Formik
      initialValues={{ dateFrom: yesterday, dateTo: now }}
      onSubmit={values => props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.USER_ACTIVITY_DETAILS)}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>View the selected user's platform activity for a chosen period.</ReportDescription>
          <ReportSection
            number={1}
            title="Reporting period"
            hint="Choose the date range included in the report."
            required
          >
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo < date) {
                  setFieldValue('dateTo', date);
                }
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>
          <ReportActions onCancel={props.onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
